export default ()=>{
  return(`

    .QRCode {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  `)
}
